(() => {
  const initialize = () => {
    document.querySelectorAll('[data-dc-clean-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const views = [...root.querySelectorAll('[data-dc-view]')];
      const main = root.querySelector('[data-dc-main]');
      const enlarged = root.querySelector('[data-dc-zoom-image]');
      const dialog = root.querySelector('[data-dc-lightbox]');
      const zoomButton = root.querySelector('[data-dc-zoom]');
      let active = 0;
      const show = index => {
        active = (index + views.length) % views.length;
        const view = views[active];
        for (const image of [main, enlarged]) { image.src = view.dataset.dcSrc; image.alt = view.dataset.dcAlt; }
        views.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
        root.querySelector('[data-dc-counter]').textContent = `${String(active + 1).padStart(2, '0')} / ${String(views.length).padStart(2, '0')}`;
      };
      views.forEach((view, i) => view.addEventListener('click', () => show(i)));
      root.querySelectorAll('[data-dc-prev]').forEach(button => button.addEventListener('click', () => show(active - 1)));
      root.querySelectorAll('[data-dc-next]').forEach(button => button.addEventListener('click', () => show(active + 1)));
      root.addEventListener('keydown', event => {
        if (!event.target.closest('.dc-clean-gallery, .dc-clean-lightbox')) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); }
      });
      zoomButton.addEventListener('click', () => { if (typeof dialog.showModal === 'function') dialog.showModal(); });
      root.querySelector('[data-dc-close-zoom]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => zoomButton.focus());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      const quantity = root.querySelector('[name="quantity"]');
      for (const [selector, change] of [['[data-dc-minus]', -1], ['[data-dc-plus]', 1]]) {
        root.querySelector(selector).addEventListener('click', () => {
          if (change > 0) quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      const variantSelect = root.querySelector('[data-dc-variant]');
      const variants = JSON.parse(root.querySelector('[data-dc-variants]').textContent);
      if (variantSelect) variantSelect.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === variantSelect.value);
        if (!variant) return;
        root.querySelector('[data-dc-price]').textContent = variant.price;
        const compare = root.querySelector('[data-dc-compare]');
        compare.hidden = !variant.compare;
        compare.textContent = variant.compare || '';
        root.querySelector('[data-dc-stock]').textContent = variant.available ? 'Disponible' : 'Agotado';
        const add = root.querySelector('[name="add"]');
        add.disabled = !variant.available;
        add.removeAttribute('aria-disabled');
        root.querySelector('[data-dc-add-label]').textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
        root.querySelector('.dc-clean-express').hidden = !variant.available;
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max !== null) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min;
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      });
    });
    document.querySelectorAll('[data-dc-open-cart]').forEach(link => {
      if (link.dataset.initialized) return;
      link.dataset.initialized = 'true';
      link.addEventListener('click', event => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { event.preventDefault(); drawer.open(link); }
      });
    });
    const country = document.getElementById('DcCountry');
    const currency = document.getElementById('DcCurrency');
    if (country && currency && !currency.dataset.initialized) {
      currency.dataset.initialized = 'true';
      country.addEventListener('change', () => {
        const code = country.selectedOptions[0]?.dataset.currency;
        for (const option of currency.options) option.selected = option.dataset.currency === code;
      });
      currency.addEventListener('change', () => { if (currency.value) country.value = currency.value; });
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
